import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "@xometry/xometry_loft";

const createAccountButton = css`
  width: 100%;
  align-self: center;
  margin: ${theme.space[6]} auto 0 auto;
`;

const flowButton = css`
  padding: 8px 12px;
`;

const Title = styled.div`
  font-size: ${theme.fontSizes[2]};
  font-weight: ${theme.fontWeights.semibold};
  line-height: ${theme.lineHeights[3]};
  padding: ${theme.space[4]};
`;

const Content = styled.div`
  line-height: 150%;
  padding: ${theme.space[3]};
  font-size: ${theme.fontSizes[0]};
  align-self: center;
  width: 85%;

  ${theme.mediaQueries.small} {
    width: 75%;
  }

  label {
    text-align: left;
    margin-top: ${theme.space[4]};
  }
  label > span {
    font-weight: ${theme.fontWeights.regular};
  }
  input {
    width: 100%;
  }
`;

const LinksWrapper = styled.span`
  line-height: ${theme.lineHeights[2]};
  font-size: ${theme.fontSizes[0]};
  margin-top: 14px;
  display: block;
`;

export { Title, createAccountButton, Content, LinksWrapper, flowButton };
